// this file is automatically generated by the scripts/git-version.js script
export const versions = {
  version: '0.0.0',
  revision: '1d056a35e9b8c910e9c2b2e776fa8bac90386471',
  branch: 'master',
  date: '1793753584105'
};
